// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_EuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Restaumatic_PromotionsEngine_Cart_CartData from "../Restaumatic.PromotionsEngine.Cart.CartData/index.js";
import * as Restaumatic_PromotionsEngine_Cart_ProductItem from "../Restaumatic.PromotionsEngine.Cart.ProductItem/index.js";
import * as Restaumatic_PromotionsEngine_Cart_PromotionalItem from "../Restaumatic.PromotionsEngine.Cart.PromotionalItem/index.js";
import * as Restaumatic_PromotionsEngine_Common from "../Restaumatic.PromotionsEngine.Common/index.js";
import * as Restaumatic_PromotionsEngine_ProductFilter from "../Restaumatic.PromotionsEngine.ProductFilter/index.js";
import * as Restaumatic_PromotionsEngine_Promotions_Promotion from "../Restaumatic.PromotionsEngine.Promotions.Promotion/index.js";
import * as Restaumatic_PromotionsEngine_Promotions_Types_Promotion from "../Restaumatic.PromotionsEngine.Promotions.Types.Promotion/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var isPromotionApplicable = function (promotion) {
    return function (productItem) {
        var v = Restaumatic_PromotionsEngine_Promotions_Promotion.promotionConditions(promotion);
        if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.CartPromotion) {
            return false;
        };
        if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.ProductPromotion) {
            return Restaumatic_PromotionsEngine_ProductFilter.inProductFilter(productItem)(Data_Record.getField(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.hasFieldProductPromotionR(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "productFilter";
                }
            })()))(Type_Proxy["Proxy"].value)(v.value0));
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Tools.Distribution (line 171, column 3 - line 173, column 92): " + [ v.constructor.name ]);
    };
};
var getSourcesTargetsRepeatableGreedy = function (dictOrd) {
    return function (normReqItems) {
        return function (productItems) {
            if (normReqItems <= 1) {
                return Data_Functor.map(Data_Functor.functorArray)(function (productItem) {
                    return new Data_Tuple.Tuple(productItem, [  ]);
                })(Data_Array.sort(Restaumatic_PromotionsEngine_Cart_ProductItem.ordProductItem(dictOrd))(productItems));
            };
            var sortedItems = Data_Array.sort(Restaumatic_PromotionsEngine_Cart_ProductItem.ordProductItem(dictOrd))(productItems);
            var targetSources = Restaumatic_PromotionsEngine_Common.splitEvery(Data_Numeric.sub(Data_Numeric.additiveInt)(normReqItems)(1))(sortedItems);
            var numTargets = Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt)(Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(productItems))(normReqItems);
            var fromCheapSortedItems = Data_Array.reverse(sortedItems);
            var cheapTargets = Data_Array.take(numTargets)(fromCheapSortedItems);
            var result = Data_Array.zip(cheapTargets)(targetSources);
            return result;
        };
    };
};
var getSourcesTargetsRepeatableFair = function (dictOrd) {
    return function (normReqItems) {
        return function (productItems) {
            return Restaumatic_PromotionsEngine_Common.targetSourcesEvery(normReqItems)(Data_Array.sort(Restaumatic_PromotionsEngine_Cart_ProductItem.ordProductItem(dictOrd))(productItems));
        };
    };
};
var getSourcesTargetsRepeatable = function (dictOrd) {
    return getSourcesTargetsRepeatableGreedy(dictOrd);
};
var getSourcesTargetsNonRepeatableFair = function (dictOrd) {
    return function (normReqItems) {
        return function (productItems) {
            return Restaumatic_PromotionsEngine_Common.splitAt(Data_Numeric.sub(Data_Numeric.additiveInt)(normReqItems)(1))(Data_Array.sort(Restaumatic_PromotionsEngine_Cart_ProductItem.ordProductItem(dictOrd))(productItems));
        };
    };
};
var getLastEqualItems = function (dictOrd) {
    return function (items) {
        var revItems = Data_Array.reverse(items);
        var v = Data_Array.head(revItems);
        if (v instanceof Data_Maybe.Just) {
            return Data_Array.takeWhile(function (i) {
                return Data_Eq.eq(Data_Money_Rounded.eqMoney)((Data_Newtype.unwrap()(i)).productPrice)((Data_Newtype.unwrap()(v.value0)).productPrice);
            })(revItems);
        };
        if (v instanceof Data_Maybe.Nothing) {
            return [  ];
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Tools.Distribution (line 162, column 5 - line 164, column 20): " + [ v.constructor.name ]);
    };
};
var getSourcesTargetsNonRepeatableGreedy = function (dictOrd) {
    return function (normReqItems) {
        return function (productItems) {
            var v = Restaumatic_PromotionsEngine_Common.splitAt(Data_Numeric.sub(Data_Numeric.additiveInt)(normReqItems)(1))(Data_Array.sort(Restaumatic_PromotionsEngine_Cart_ProductItem.ordProductItem(dictOrd))(productItems));
            return new Data_Tuple.Tuple(v.value0, getLastEqualItems(dictOrd)(v.value1));
        };
    };
};
var getSourcesTargetsNonRepeatable = function (dictOrd) {
    return getSourcesTargetsNonRepeatableGreedy(dictOrd);
};
var findApplicableProducts = function (productItems) {
    return function (promotion) {
        return Data_Array.filter(isPromotionApplicable(promotion))(productItems);
    };
};
var createSingleProductPromotionalItems = function (dictOrd) {
    return function (promotion) {
        return function (assignmentMode) {
            return function (v) {
                var productItemKeyTarget = Restaumatic_PromotionsEngine_Cart_ProductItem.productItemKey(v.value1.value0);
                var productItemKeySources = Data_Functor.map(Data_Functor.functorArray)(Restaumatic_PromotionsEngine_Cart_ProductItem.productItemKey)(v.value1.value1);
                return Restaumatic_PromotionsEngine_Cart_PromotionalItem.mkDefaultPromotionalItem(v.value0)(promotion)(assignmentMode)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.mkTargetItems(Data_Foldable.foldableArray)(dictOrd)([ productItemKeyTarget ]))(Restaumatic_PromotionsEngine_Cart_PromotionalItem.mkSourceItems(productItemKeySources));
            };
        };
    };
};
var createProductPromotionalItemsRepeatable = function (dictOrd) {
    return function (requirements) {
        return function (itemId) {
            return function (promotion) {
                return function (assignmentMode) {
                    return function (productItems) {
                        var normReqItems = Data_Ord.max(Data_Ord.ordInt)(1)(Restaumatic_PromotionsEngine_Promotions_Promotion.numRequiredItems(requirements));
                        var applicableProductItems = findApplicableProducts(productItems)(promotion);
                        var distributedProducts = getSourcesTargetsRepeatable(dictOrd)(normReqItems)(applicableProductItems);
                        var count = Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(distributedProducts);
                        var distributedProductsWithIds = Data_Array.zip(Data_Array.range(itemId)(Data_Numeric.add(Data_Numeric.additiveInt)(itemId)(count)))(distributedProducts);
                        var result = Data_Functor.map(Data_Functor.functorArray)(createSingleProductPromotionalItems(dictOrd)(promotion)(assignmentMode))(distributedProductsWithIds);
                        return result;
                    };
                };
            };
        };
    };
};
var createProductPromotionalItemsNonRepeatable = function (dictOrd) {
    return function (requirements) {
        return function (itemId) {
            return function (promotion) {
                return function (assignmentMode) {
                    return function (productItems) {
                        var normReqItems = Data_Ord.max(Data_Ord.ordInt)(1)(Restaumatic_PromotionsEngine_Promotions_Promotion.numRequiredItems(requirements));
                        var applicableProductItems = findApplicableProducts(productItems)(promotion);
                        var v = getSourcesTargetsNonRepeatable(dictOrd)(normReqItems)(applicableProductItems);
                        var sourceIds = Data_Functor.map(Data_Functor.functorArray)(Restaumatic_PromotionsEngine_Cart_ProductItem.productItemKey)(v.value0);
                        var applicableIds = Data_Functor.map(Data_Functor.functorArray)(Restaumatic_PromotionsEngine_Cart_ProductItem.productItemKey)(v.value1);
                        var result = (function () {
                            var $41 = Data_Foldable["null"](Data_Foldable.foldableArray)(applicableIds);
                            if ($41) {
                                return [  ];
                            };
                            return Control_Applicative.pure(Control_Applicative.applicativeArray)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.mkDefaultPromotionalItem(itemId)(promotion)(assignmentMode)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.mkTargetItems(Data_Foldable.foldableArray)(dictOrd)(applicableIds))(Restaumatic_PromotionsEngine_Cart_PromotionalItem.mkSourceItems(sourceIds)));
                        })();
                        return result;
                    };
                };
            };
        };
    };
};
var createProductPromotionalItems = function (dictOrd) {
    return function (requirements) {
        return (function () {
            var $44 = Restaumatic_PromotionsEngine_Promotions_Promotion.repeatable(requirements);
            if ($44) {
                return createProductPromotionalItemsRepeatable(dictOrd);
            };
            return createProductPromotionalItemsNonRepeatable(dictOrd);
        })()(requirements);
    };
};
var distributePromotion = function (dictOrd) {
    return function (inputCartData) {
        return function (itemId) {
            return function (promotion) {
                var assignmentMode = Restaumatic_PromotionsEngine_Cart_CartData.assignmentMode(inputCartData);
                var v = Restaumatic_PromotionsEngine_Promotions_Promotion.promotionConditions(promotion);
                if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.CartPromotion) {
                    return new Data_Tuple.Tuple(Data_Numeric.add(Data_Numeric.additiveInt)(itemId)(1), Control_Applicative.pure(Control_Applicative.applicativeArray)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.mkDefaultPromotionalItem(itemId)(promotion)(assignmentMode)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.mkTargetCart)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.mkNoSource)));
                };
                if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.ProductPromotion) {
                    var items = createProductPromotionalItems(dictOrd)(v.value0)(itemId)(promotion)(assignmentMode)(Restaumatic_PromotionsEngine_Cart_CartData.productItems(inputCartData));
                    return new Data_Tuple.Tuple(Data_Numeric.add(Data_Numeric.additiveInt)(itemId)(Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(items)), items);
                };
                throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Tools.Distribution (line 44, column 5 - line 51, column 46): " + [ v.constructor.name ]);
            };
        };
    };
};
var genAndAppendPromotionalItems = function (dictOrd) {
    return function (inputCartData) {
        return function (v) {
            return function (promotion) {
                var v1 = distributePromotion(dictOrd)(inputCartData)(v.value0)(promotion);
                return new Data_Tuple.Tuple(v1.value0, Data_Semigroup.append(Data_Semigroup.semigroupArray)(v.value1)(v1.value1));
            };
        };
    };
};
var distributePromotions = function (dictOrd) {
    return function (inputCartData) {
        return function (promotions) {
            var v = Data_Foldable.foldl(Data_Foldable.foldableArray)(genAndAppendPromotionalItems(dictOrd)(inputCartData))(new Data_Tuple.Tuple(1, [  ]))(promotions);
            return v.value1;
        };
    };
};
export {
    distributePromotions
};
//# sourceMappingURL=index.js.map
